// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1s8cG","author":"Table_author__1hJ0n","authorImage":"Table_authorImage__1iJrP","unreadRow":"Table_unreadRow__3JTHn"};